module.exports = __webpack_public_path__ + "img/des4.b400e90e.png";